module.exports = require('./lib/effects')


//////////////////
// WEBPACK FOOTER
// ./~/redux-saga/effects.js
// module id = 1225
// module chunks = 14